export default __webpack_public_path__ + "static/media/2.6bd08331.jpg";